import { useTranslation } from 'react-i18next'
import {
  invalidateProductCertificationByProductIdCache,
  useAddProductCertification,
} from 'src/api/product-certification'
import { ShowDialogProps } from 'src/show-dialog'
import { ProductCertificationForm } from './ProductCertificationForm'
import { toast } from 'react-toastify'
import { invalidateComponentsCache } from 'src/api/components'

interface CreateProductCertificateDialogProps extends ShowDialogProps {
  productId: EntityId
}
export const CreateProductCertificateDialog: React.FC<CreateProductCertificateDialogProps> = ({ pop, productId }) => {
  const { t } = useTranslation(['main-component', 'common', 'certificate'])

  const mutation = useAddProductCertification()

  const onSubmit = async form => {
    form.productId = productId
    await mutation.mutateAsync(form, {
      onSuccess: () => {
        toast.success(t('SuccessfullyCreated', { ns: 'common-api-message' }))
        invalidateProductCertificationByProductIdCache.getProductCertificationByProductId(productId)
        invalidateComponentsCache.getComponents()
        pop()
      },
      onError: () => {
        toast.error(t('InternalError', { ns: 'common-api-message' }))
      },
    })
  }

  return (
    <ProductCertificationForm
      title={t('create-product-certificate', { ns: 'product' })}
      onSubmit={onSubmit}
      onCancel={() => pop()}
    />
  )
}
